import { Axios } from "../../../util";

const searchPaymentAPI = async (payload) => {
  try {
    const res = await Axios.post('/api/payment/search',payload);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const inquiryAPI = async (referenceNumber) => {
  try {
    const res = await Axios.post(`/api/payment/inquiry?referenceNumber=${referenceNumber}`);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};



export { searchPaymentAPI,
         inquiryAPI };
